<script>
import {mapActions, mapGetters} from "vuex";
import {
  getBusinessCardsDoc,
  getQueryBusinessCardsCollection,
  getQueryByCollectionName,
  getQueryPostCollection,
  queryByCollectionName,
  queryConnectionsCollection,
  queryEventAttendeesCollection
} from "@/shared/firebase_utils";
import {where, limit, getCountFromServer, getDocs, startAfter, query} from "firebase/firestore";
import Loading from "@/components/Loading.vue";

export default {
  name: "PostAnalyticsDetails",
  components: {Loading},
  data() {
    return {
      postsData: [],
      type: null,
      currentEventId: null,
      headers: [
        {
          text: "",
          value: "image",
          align: "end",
        },
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "Job Title",
          value: "jobTitle",
          align: "start",
        },
        {
          text: "Posts created",
          value: "postsCreated",
          align: "start",
        }
      ],
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    breadCrumbItems() {
      if (this.currentEvent) {

        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 5}
          },
          {
            text: 'Analytics',
            disabled: false,
            routeName: "editMultiConnect",
            params: {
              eventId: this.currentEvent.id,
            },
            query: {tab: 5}
          },
          {
            text: this.pageTitle,
            disabled: true,
            routeName: "postAnalytics",
            params: {
              eventId: this.currentEvent.id,
            },
          },
        ];
        return items;
      } else return [];
    },

    headerDetails() {
      return [
        {
          title: "posts created",
          icon: "post-add",
          value: this.totalCreatedPost,
        },

      ];
    },
    totalCreatedPost() {
      if (this.isSessionPost) {
        return this.currentEvent.analyticsData.postsAnalytics.sessionPosts
      }
      if (this.isAnnouncementPost) {
        return this.currentEvent.analyticsData.postsAnalytics.announcementPosts
      }
      if (this.isGeneralPost) {
        return this.currentEvent.analyticsData.postsAnalytics.generalPosts
      }
    },
    isSessionPost() {
      return this.type === "session";
    },
    isAnnouncementPost() {
      return this.type === "announcement";
    },
    isGeneralPost() {
      return this.type === "general";
    },
    pageTitle() {
      if (this.isSessionPost) {
        return "Session Content Posts";
      } else if (this.isAnnouncementPost) {
        return "Announcement Posts";
      } else if (this.isGeneralPost) {
        return "General Posts";
      }
      return "";
    }
  },
  methods: {
    ...mapActions(["initializeCurrentEvent"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    async getPostDetails(businessCardId, postCount) {
      const businessCard = await getBusinessCardsDoc(businessCardId);

      if (businessCard.data() !== undefined) {
        const displayName = businessCard.data().firstName + " " + businessCard.data().lastName;
        const displayImageUrl = businessCard.data().displayImageUrl ? businessCard.data().displayImageUrl : '';
        return {
          displayImageUrl: displayImageUrl,
          name: displayName,
          businessName: businessCard.data().businessName,
          jobTitle: businessCard.data().jobTitle,
          postsCreated: postCount,
        };
      }
    },
    async getPostsData() {
      let postQuery;
      if (this.isSessionPost) {
        postQuery = getQueryPostCollection(
            where("feedType", "==", "session"),
            where("eventId", "==", this.currentEventId)
        );
      }
      if (this.isAnnouncementPost) {
        postQuery = getQueryPostCollection(
            where("isAnnouncement", "==", true),
            where("eventId", "==", this.currentEventId)
        );
      }
      if (this.isGeneralPost) {
        postQuery = getQueryPostCollection(
            where("feedType", "==", "event"),
            where("isAnnouncement", "==", false),
            where("eventId", "==", this.currentEventId)
        );
      }
      const data = (await postQuery).docs.map(doc => doc.data());
      const groupedPosts = Object.groupBy(data, ({businessCardId}) => businessCardId);
      const postDetails = await Promise.all(Object.keys(groupedPosts).map(businessCardId => {
        return this.getPostDetails(businessCardId, groupedPosts[businessCardId].length);
      }));

      this.postsData = postDetails.filter(data => data!==undefined);
    },
    async saveEvent() {
      await this.initializeCurrentEvent(this.currentEventId);
      await this.getPostsData();
    }
  },
  created() {
    this.type = this.$route.query.type;
    this.currentEventId = this.$route.params.eventId;
    this.saveEvent();
  }
}
</script>

<template>
  <v-container fluid :class="currentEvent == null || !this.postsData ? 'fill-height' : ''">
    <v-row v-if="currentEvent == null || !this.postsData">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>
            {{ this.pageTitle }}
          </v-card-title>
          <v-col>
            <v-row>
              <div v-for="item in headerDetails">
                <div style="background-color: #F6F7FC; border-radius: 6px" class="ma-4">
                  <v-row class="ma-auto px-4 py-2" align="center">
                    <img :src="require(`@/assets/icons/${item.icon}.svg`)" height="30" width="35" style="color: black"
                         class="pr-2">{{ item.value }} {{ item.title }}
                  </v-row>
                </div>
              </div>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="postsData"
                :items-per-page="-1"
                hide-default-footer
            >
              <template v-slot:[`item.image`]="{ item }">
                <v-avatar size="40">
                  <v-img :src="item.displayImageUrl"/>
                </v-avatar>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <span>{{ item.name }}</span>
              </template>
              <template v-slot:[`item.businessName`]="{ item }">
                <span>{{ item.businessName }}</span>
              </template>
              <template v-slot:[`item.jobTitle`]="{ item }">
                <span>{{ item.jobTitle }}</span>
              </template>
              <template v-slot:[`item.postsCreated`]="{ item }">
                <span>{{ item.postsCreated }}</span>
              </template>
            </v-data-table>

          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<style scoped>

</style>